import { useTranslation } from "react-i18next";
import GenericComponent from "../../utils/genericComponent/GenericComponent";
import { ReactComponent as Image } from "../../../assets/img/signing-illustration.svg";
import { useCallback, useMemo, useState } from "react";
import { useFlow } from "../../../hooks/useFlow/useFlow";
import { Request } from "../../../models/request/request.model";
import { store } from "../../../redux/store";
import { Documents } from "../../../models/documents/documents.model";
import { Button } from "react-corner-ds";
import style from "./ContractView.module.css";
import { saveBase64Pdf, mockDummyPdf } from "../../../utils/fileDownloader";

const ContractView = () => {
  const { t } = useTranslation();
  const [nextStepLoading, setNextStepLoading] = useState(false);
  const [contractDownloaded, setContractDownloaded] = useState(false);
  const { callSteploader } = useFlow();

  const documents: Documents = useMemo(
    () =>
      store.getState().pega.Data?.Documents
        ? store.getState().pega.Data?.Documents
        : [],
    []
  );

  const downloadContract = useCallback(async () => {
    let base64 = documents[0] ? documents[0].Base64 : mockDummyPdf;
    saveBase64Pdf(base64, documents[0] ? documents[0].Title : "");
    setContractDownloaded(true);
  }, [documents]);

  const submitHandler = useCallback(async () => {
    let body: Request = {
      Data: {
        FlowDirection: "Next",
      },
      Extra: {},
    };
    setNextStepLoading(true);
    await callSteploader(body);
  }, [callSteploader]);

  return (
    <>
      <GenericComponent
        ImageSrc={Image}
        pageTitle={t`screens.contractView.pageTitle`}
        pageSubtitle={t`screens.contractView.pageSubtitle`}
        transComponent={<br />}
      />
      <div className={style.btnHolder + " btnHolder"}>
        <Button
          text={t`screens.contractView.downloadBtn`}
          onClick={downloadContract}
          disabled={contractDownloaded}
        />
      </div>
      <div className={style.btnHolder + " btnHolder"}>
        {contractDownloaded && (
          <Button
            text={t`screens.contractView.btnNext`}
            onClick={submitHandler}
            disabled={nextStepLoading}
            icon={
              nextStepLoading
                ? { icon: "loader", position: "right", spin: true }
                : undefined
            }
          />
        )}
      </div>
    </>
  );
};

export default ContractView;
